/* eslint-disable max-len  */
/* eslint-disable no-template-curly-in-string */
export default {}
